import React, { useEffect } from "react";
import get from "lodash/get";
import { useDispatch, useSelector } from "react-redux";

import { OPEN_HAMBURGER_MENU, OPEN_SEARCHBAR } from "../../store/actions";
import HamburgerMenu from "../../atoms/hamburger-menu";
// import NotificationIcon from "../../atoms/icons/notificarions";

import "./hamburger-and-notification.m.css";

const HamburgerNotification = () => {
  const dispatch = useDispatch();
  const getState = useSelector((state) => state);
  const isHamburgerMenuOpen = get(getState, ["isHamburgerMenuOpen"], false);

  useEffect(() => {
    if (typeof window !== "undefined") {
      if (isHamburgerMenuOpen) {
        // document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "";
      }
    }
  }, [isHamburgerMenuOpen]);

  const toggleHandler = () => {
    dispatch({
      type: OPEN_HAMBURGER_MENU,
      isHamburgerMenuOpen: !isHamburgerMenuOpen
    });
    dispatch({
      type: OPEN_SEARCHBAR,
      isSearchBarOpen: false
    });
  };

  return (
    <div styleName="wrapper">
      <div>
        <HamburgerMenu
          isMobileHamburger={false}
          onMenuToggle={() => toggleHandler()}
          isMegaMenuOpen={isHamburgerMenuOpen}
        />
      </div>
      {/* <div styleName="notification-icon">
        <NotificationIcon />
      </div> */}
    </div>
  );
};

export default HamburgerNotification;
